module.exports = __webpack_public_path__ + "static/media/landscape_nosetoliptochin.4aa50b53.jpg";